import React from 'react';
import { SearchableSelect } from '@shared/components';
import { useAddOnsQuery } from '../hooks/useAddOnsQuery';
import type { AddOnRecord } from '../services/smr-admin';

interface Props {
    value: AddOnRecord | null;
    onChange: (next: AddOnRecord | null) => void;
    excludeIds?: string[];
    disabled?: boolean;
    id?: string;
}

export function AddOnCombobox({ value, onChange, excludeIds = [], disabled = false, id }: Props) {
    // SearchableSelect owns the debounce and emits only settled terms via onSearchChange.
    const [term, setTerm] = React.useState('');
    const { data, isFetching } = useAddOnsQuery({ search: term, status: 'active', per_page: 20 });

    return (
        <SearchableSelect<AddOnRecord>
            options={data?.data ?? []}
            value={value}
            onChange={onChange}
            getOptionValue={(o) => o.id}
            getOptionLabel={(o) => o.name}
            onSearchChange={setTerm}
            loading={isFetching}
            excludeValues={excludeIds}
            disabled={disabled}
            id={id}
            placeholder="Search active optional extras…"
            emptyLabel="No active optional extras match."
            renderOption={(o) =>
                o.category ? (
                    <>
                        {o.name}
                        <span className="text-mp-muted text-xs ml-1">({o.category})</span>
                    </>
                ) : (
                    o.name
                )
            }
        />
    );
}
